import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainBlock() {
  const painPoints = ['El silencio incómodo después de un mensaje que nunca contestó.', "Ver a un tipo que 'nada que ver' llevarse la atención que vos merecés.", 'La frustración de que todo fluya por suerte y no saber cómo repetirlo.', 'Quedarte mirando el teléfono un domingo a la noche sin planes.', "Sentir que tenés que 'actuar' para gustar, en lugar de ser vos."];
  return <section className="py-24 md:py-32 px-4 bg-bg-pain border-t border-red-border space-y-[0px]" data-id="element-160">
      <div className="max-w-[800px] mx-auto" data-id="element-161">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-primary font-display font-bold text-3xl md:text-4xl mb-8 text-center" data-id="element-162">
          ¿Cuántas noches más vas a aceptar que 'no se dio'?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-text-secondary text-base md:text-lg mb-12 text-center leading-relaxed max-w-[640px] mx-auto" data-id="element-163">
          Tenés el trabajo, tenés el auto, tenés tu vida. Pero cuando se trata
          de atracción, seguís dependiendo de la{' '}
          <span className="text-red-urgency" data-id="element-164">suerte</span>. Ves a otros con
          menos que vos lograrlo fácil mientras vos te quedás recalculando qué{' '}
          <span className="text-red-urgency" data-id="element-165">falló</span>.
        </motion.p>

        <div className="space-y-4 mb-14" data-id="element-166">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-bg-section-alt border-l-[3px] border-red-urgency rounded-r-lg p-5 flex items-start gap-4" data-id="element-167">
              <XCircle className="text-red-urgency flex-shrink-0 mt-0.5" size={20} data-id="element-168" />
              <span className="text-text-primary text-base font-medium" data-id="element-169">
                {point}
              </span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-primary text-xl md:text-2xl italic text-center font-bold" data-id="element-170">
          El próximo fin de semana podrías no estar leyendo esto.
        </motion.p>
      </div>
    </section>;
}